// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Avatar, Col, Dropdown, Input, Row, Badge } from "antd";
import moment from "moment";
import { User, Search, Bell } from "lucide-react";

import { WrapperActionsRight, WrapperHeader } from "../layouts";
import { useNavBar } from "./hooks";

export const NavBar = ({ collapsed, title }: { collapsed: boolean, title?: string }) => {
  const { user, logout } = useNavBar();

  const menuItems = [
    {
      key: "user",
      label: (
        <div style={{ padding: "8px 0", borderBottom: "1px solid #f0f0f0" }}>
          <div style={{ fontWeight: 600, color: "#2d3748", marginBottom: 4 }}>
            {user?.first_name} {user?.last_name}
          </div>
          <div style={{ fontSize: "12px", color: "#718096" }}>
            {user?.email}
          </div>
        </div>
      ),
    },
    {
      key: "build",
      label: (
        <div style={{ fontSize: "12px", color: "#718096", padding: "4px 0" }}>
          Miembro desde: {moment(`${user?.createdAt}`).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      label: (
        <span style={{ color: "#e53e3e", fontWeight: 500 }}>
          Cerrar Sesión
        </span>
      ),
      onClick: logout,
    },
  ];

  return (
    <WrapperHeader style={{ left: collapsed ? "80px" : "260px" }}>
      <Row align="middle" style={{ width: "100%", gap: "20px" }}>
        <Col>
          <h2 style={{ 
            margin: 0, 
            fontSize: "20px", 
            fontWeight: 600, 
            color: "#1e293b",
            letterSpacing: "-0.01em"
          }}>
            {title || "Panel de Administración"}
          </h2>
        </Col>

        <Col
          style={{
            display: "flex",
            flexGrow: 1,
          }}
        />
        
        <WrapperActionsRight style={{ gap: "16px" }}>
          <Badge count={0} showZero={false}>
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.2s",
                backgroundColor: "#f7fafc",
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#e2e8f0"}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#f7fafc"}
            >
              <Bell size={18} color="#718096" />
            </div>
          </Badge>

          <Dropdown menu={{ items: menuItems }} placement="bottomRight" trigger={['click']}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                cursor: "pointer",
                padding: "6px 12px",
                borderRadius: "8px",
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f7fafc"}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
            >
              <Avatar 
                size={36} 
                icon={<User size={18} />}
                style={{
                  backgroundColor: "var(--primary)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
              <div style={{ display: "flex", flexDirection: "column", lineHeight: "1.2" }}>
                <span style={{ fontSize: "14px", fontWeight: 500, color: "#2d3748" }}>
                  {user?.first_name || "Usuario"}
                </span>
                <span style={{ fontSize: "12px", color: "#718096" }}>
                  Administrador
                </span>
              </div>
            </div>
          </Dropdown>
        </WrapperActionsRight>
      </Row>
    </WrapperHeader>
  );
};
